import {$} from '../jquery-definition.js';

$( window ).scroll( function() {
	$( 'video.autoplay-in-view' ).each( function() {
		if ( $( this ).is( ':in-viewport' ) ) {
			$( this )[ 0 ].play();
		} else {
			$( this )[ 0 ].pause();
		}
	} );
} );
